<template>
  <div class="ui fluid card" style="background-color: #222a34; width:100%">
    <div class="content" style="color:white;">
      <div class="ui inverted header" style="color: white;">
        <a class="ui orange small horizontal label" style="margin-left:0; margin-bottom:0.5em;">New</a>
        {{ currentLesson.data.title }}
        <div class="sub header">
          <i class="calendar icon"></i> Day {{ currentLesson.data.options.startDay }}
        </div>
      </div>
    </div>
    <div class="image">
      <img src="https://dummyimage.com/1000x1/222a34/222a34.gif">
      <img v-if="currentLesson.data.imageLink" :src="currentLesson.data.imageLink">
    </div>
    <div class="content" style="color: #ffffff" v-html="currentLesson.data.body"></div>
    <div class="extra content">
      <button class="ui small secondary button"
              v-if="currentLesson.data.options.secondaryText">
        <i :class="generateIconClass(currentLesson.data.options.secondaryIcon)"></i>
        {{ currentLesson.data.options.secondaryText }}
      </button>
      <button class="ui right floated primary small button"
              v-if="currentLesson.data.options.primaryText">
        <i :class="generateIconClass(currentLesson.data.options.primaryIcon)"></i>
        {{ currentLesson.data.options.primaryText }}
      </button>
    </div>
  </div>
</template>

<script>
	export default {
	  props: {
      currentLesson: {
	      type: Object,
        required: false
      }
    },
		data() {
			return {}
		}
	}
</script>

<style scoped>
    .primary {
      background-color: #3e838a !important;
    }

    .secondary {
      background-color: #3e838a !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/content/PreviewLessonPlan.vue